import type { RouteRecordRaw } from 'vue-router'

export const dashboardRoute: RouteRecordRaw = {
  name: 'dashboard',
  path: '/',
  component: () => import('./DashboardModule.vue'),
  meta: {
    title: 'Dashboard',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'dashboards-index',
      component: () => import('./views/DashboardIndex.vue'),
    },
  ],
}
